export const SEEK_FUDGE_SECS = 5;
export const POS_CALC_FREQ_SECS = 1;
export const UPDATE_FREQ_MILLIS = 5000;
/* ABLY_API_KEY is now set in index.html for compatibility with the Stadion deployment. FIXME */